<ngx-spinner bdColor = "rgba(0,0,0,0.64)" size = "medium" color = "#fff" type = "line-scale" [fullScreen] = "true"></ngx-spinner>


<div class="content">
   <form action="" id="frmLogin" name="frmLogin" method="post" accept-charset="utf-8">
      <div class="row">
         <div class="col s12 input-field s10" id="wrapUserID">
            
            <input [(ngModel)]='user.em' #pre="ngModel" value="{{cemail}}" required name="em" type="email" class="validate" id="userId" maxlength="50" data-scanning="inputId"><label for="userId" data-language="page.p101.msg02" class="">이메일 주소</label></div>
      </div>
      <div class="row">
         <div class="col s12 input-field s10" id="wrapUserPW">
            
            <input [(ngModel)]='user.ps' #pre="ngModel" required name="ps" type="password" class="validate" id="userPw" maxlength="64" data-scanning="inputPw" autocomplete="off"><label for="userPw" data-language="common.msg08">비밀번호</label></div>


         <div class="col s5 input-field right-align hide" id="wrapSMS"><span class="btn btn-flat waves-effect" id="btnSMS" data-scanning="btnSMS" data-language="common.head.msg117">인증번호요청</span></div>
         <div class="sms_time hide"></div>
      </div>
   </form>
   <div class="wrongpass" >로그인 정보가 일치하지 않습니다.</div>


   <div class="row">
      <div (click)="psteml()" class="btn_orange btn-large col s12 center-align waves-effect" id="btnLogin" data-scanning="btnLogin" data-language="common.msg295">

         <span [style.display]="flag1 ? color3 : color2" >  <i class="fas fa-spinner fa-spin"></i></span>
         <span [style.display]="flag1 ? color2 : color3" class="waves-effect">로그인</span>         
      
      </div>
   </div>


   <ul class="notice list">

   </ul>
</div>










<ul class="bottomMenu">
   <li class=""><a href="/" data-language="common.head.msg22" class="GA_PUBLIC_BOTTOM_MENU_HOME"><i class="sp-mobile-head trade"></i>거래소</a></li>
   <li class="">
      <a href="/additional_service/lending_kind" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_LENDING">
         <div class="ico_container"><i class="icoNew icoNewMenu">N</i></div>
         <i class="sp-mobile-head lending"></i>렌딩
      </a>
   </li>
   <li class=""><a href="/asset_status/asset_my" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_ASSET"><i class="sp-mobile-head asset"></i>자산현황</a></li>
   <li class=""><a href="/trade/statement" data-language="page.common.msg583" class="GA_PUBLIC_BOTTOM_MENU_DEPOSIT"><i class="sp-mobile-head depositNWithdraw"></i>입출금</a></li>
   <li class=""><a href="/main/more_index" data-language="page.common.msg777" class=""><i class="sp-mobile-head more-menu"></i>더보기</a></li>
</ul>
